import React, { Component } from 'react';
import HeroSection from "../components/HeroSection.js"
import NewsSection from "../components/NewsSection.js"
import MenuHighlights from "../components/MenuHighlights.js"
import OrderStrip from "../components/OrderStrip.js"
import BrandTeaser from "../components/BrandTeaser.js"
import PressRecognition from "../components/PressRecognition.js"
import LogoSplash from "../components/LogoSplash.js"
import StickyMobileCTA from "../components/StickyMobileCTA.js"
import Footer from "../components/Footer.js"
import NavBar from "../components/NavBar.js"

import '../css/main.css';

class HomePage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      splashDone: !!sessionStorage.getItem('doday_splash_shown')
    };
  }

  componentDidMount() {
    this.observeRevealElements();
  }

  componentDidUpdate() {
    this.observeRevealElements();
  }

  observeRevealElements() {
    const allRevealEls = document.querySelectorAll('.reveal:not(.visible)');

    if ('IntersectionObserver' in window) {
      if (this.observer) this.observer.disconnect();
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              this.observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.05, rootMargin: '50px 0px 50px 0px' }
      );
      allRevealEls.forEach(el => this.observer.observe(el));
    } else {
      allRevealEls.forEach(el => el.classList.add('visible'));
    }
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect();
  }

  handleSplashComplete = () => {
    this.setState({ splashDone: true });
  }

  render() {
    return (
        <div id="body">
          <LogoSplash onComplete={this.handleSplashComplete} />
          <NavBar />

          <HeroSection />

          <PressRecognition />

          <MenuHighlights />

          <OrderStrip />

          <BrandTeaser />

          <NewsSection />

          <StickyMobileCTA />

          <Footer />
        </div>
    );
  }
}

export default HomePage;
